import { ComponentProps, forwardRef } from 'react';
import { Typography } from 'antd';
import styles from './BaseFormTitle.module.scss';

type BaseFormTitleProps = ComponentProps<typeof Typography.Text>;

export const BaseFormTitle = forwardRef<HTMLSpanElement, BaseFormTitleProps>(
  ({ className, ...props }, ref) => (
    <Typography.Text
      ref={ref}
      className={[styles.title, className].filter(Boolean).join(' ')}
      {...props}
    />
  )
);
